import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, storeSession } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((response) => {
        storeSession(response.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true });
      })
      .catch(() => setError("Google sign-in could not be completed. Please try again."));
  }, [location.hash, navigate]);

  return <main className="auth-form-side" data-testid="google-auth-callback">{error || "Signing you in securely..."}</main>;
}